// import React, { useState } from "react";
// import { Table } from "antd";
// import { useSelector } from "react-redux";

// const RawGrid = ({ report, meters, parameter }) => {
// console.log(meters)
// console.log(parameter)
//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   const [tableParams, setTableParams] = useState({
//     pagination: {
//       current: 1,
//       pageSize: 100,
//     },
//   });

//   const handleTableChange = (pagination, filters, sorter) => {
//     setTableParams({
//       pagination,
//       filters,
//       ...sorter,
//     });
//   };

//   let columns = [];
//   columns.push({ title: "Date", dataIndex: "date", fixed: "left", width: "200px" });
//   if (parameter) {
//     // If the condition is true, add two sub-columns for each meter
//     meters?.forEach((key) => {
//       columns.push({
//         title: key,
//         width: "200px",
//         align: "center",
//         dataIndex: `${key}`,
//         key: `${key}`,
//         render: (text, record) => record[`${key}`],
//         fixed: "top", 
//       });
//     });
//   } else {
//     // If the condition is false, add a single column for each meter
//     meters?.forEach((key) =>
//       columns.push({
//         title: key,
//         width: "200px",
//         align: "center",
//         dataIndex: key,
//         key: key,
//         render: (text, record) => record[key],
//         fixed: "top",
//       })
//     );
//   }

//   const totalWidth = columns.reduce((acc, column) => acc + parseInt(column.width || 0, 100), 0);

//   return (
//     <Table
//     columns={columns}
//     dataSource={report}
//     onChange={handleTableChange}
//     pagination={tableParams.pagination}
//     scroll={{ x: totalWidth, y: "450px" }}
//     className={` dark ${isdarkMode ? 'ant-table-expanded-row-fixed-background ant-empty-description ant-table-cell custom-table-dark ' : 'whitemode'} `}
    
//   />
//   );
// };

// export default RawGrid;




// import React, { useState, useMemo } from "react";
// import { Table, Select, Button, Spin, Result } from "antd";
// import { useSelector } from "react-redux";

// const { Option } = Select;

// const RawGrid = ({ report, meters, parameter }) => {
//   const mode = useSelector((state) => state.darkMode);
//   const { isdarkMode } = mode;

//   const [selectedColumns, setSelectedColumns] = useState([]);
//   const [tableParams, setTableParams] = useState({
//     pagination: {
//       current: 1,
//       pageSize: 100,
//     },
//   });

//   const handleTableChange = (pagination, filters, sorter) => {
//     setTableParams({
//       pagination,
//       filters,
//       ...sorter,
//     });
//   };

//   const allColumns = useMemo(() => {
//     const cols = [
//       { title: "Date", dataIndex: "date", fixed: "left", width: "200px" }
//     ];
    
//     if (parameter) {
//       meters.forEach((key) => {
//         cols.push({
//           title: key,
//           width: "200px",
//           align: "center",
//           dataIndex: `${key}`,
//           key: `${key}`,
//           render: (text, record) => record[`${key}`],
//           fixed: "top",
//         });
//       });
//     } else {
//       meters.forEach((key) =>
//         cols.push({
//           title: key,
//           width: "200px",
//           align: "center",
//           dataIndex: key,
//           key: key,
//           render: (text, record) => record[key],
//           fixed: "top",
//         })
//       );
//     }
//     return cols;
//   }, [meters, parameter]);

//   const displayedColumns = useMemo(() => {
//     const dateColumn = allColumns.find(col => col.dataIndex === "date");
//     const otherColumns = allColumns.filter(col => col.dataIndex !== "date");

//     return [dateColumn, ...selectedColumns];
//   }, [allColumns, selectedColumns]);

//   const handleColumnChange = (values) => {
//     setSelectedColumns(values.map(value => allColumns.find(col => col.dataIndex === value)));
//   };

//   const totalWidth = displayedColumns.reduce((acc, column) => acc + parseInt(column.width || 0, 100), 0);


//   let locale = {
//     emptyText: (
//       <Result
//         title="Loading.."
      
//       />
//     )
//   };


 
//   return (
//     <div>
//       <div className="flex justify-between items-center mb-2">
//         {/* <Select
//          dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}
//           mode="multiple"
//           placeholder="Select columns"
//           onChange={handleColumnChange}
//           style={{ width: 200 }}
//         >
//           {allColumns.filter(col => col.dataIndex !== "date").map(col => (
//             <Option key={col.dataIndex} value={col.dataIndex}>
//               {col.title}
//             </Option>
//           ))}
//         </Select> */}
        
//       </div>
//       <Table
//       //  locale={locale}
//       // loading={{ indicator: <div><Spin /></div>}} 

//         columns={displayedColumns}
//         dataSource={report}
//         onChange={handleTableChange}
//         pagination={tableParams.pagination}
//         scroll={{ x: totalWidth, y: "450px" }}
//         className={`dark ${isdarkMode ? 'ant-table-expanded-row-fixed-background ant-empty-description ant-table-cell custom-table-dark' : 'whitemode'}`}
//       />
//     </div>
//   );
// };

// export default RawGrid;



import React, { useState } from "react";
import { Result, Table } from "antd";
import { useSelector } from "react-redux";


const RawGrid = ({ report, meters, parameter }) => {

  console.log(meters)
  

  console.log(report)
  console.log(parameter)
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  let columns = [];
  // columns.push({ title: "Date", dataIndex: "date", fixed: "left",
  //    width: "200px" ,
  //    sorter: (a, b) => new Date(a.date) - new Date(b.date)}    );
  columns.push({
    title: "Date",
    dataIndex: "date",
    fixed: "left",
    width: "200px",
    sorter: (a, b) => {
      const parseDateTime = (dateTimeStr) => {
        // Split date and time parts
        const [datePart, timePart] = dateTimeStr.split(', ');
        const [day, month, year] = datePart.split('/');
        const dateTime = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')} ${timePart}`;
        return new Date(dateTime);
      };
      
      return parseDateTime(a.date) + parseDateTime(b.date);
    },
    // Optional: Render function to ensure consistent display format
    render: (date) => date 
  });
  
  if (parameter) { 
    // If the condition is true, add two sub-columns for each meter
    meters?.forEach((key) => {
      columns.push({
        title: key,
        width: "200px",
        align: "center",
        dataIndex: `${key}`,
        key: `${key}`,
        render: (text, record) => record[`${key}`],
        fixed: "top",
        sorter: (a, b) => a[key] - b[key], // Numeric comparison
      });
    });
  } else {
    meters?.forEach((key) =>
      columns.push({
        title: key,
        width: "200px",
        align: "center",
        dataIndex: key,
        key: key,
        render: (text, record) => record[key],
        fixed: "top",
      })
    );
  }
  
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const totalWidth = columns.reduce((acc, column) => acc + parseInt(column.width || 0, 100), 0);
  let locale = {
        emptyText: (
          <Result
            title="Loading.."
            className={` ${isdarkMode ? 'darkfont' : 'whitemode'}`}
           

          />
        )
      };

      console.log(columns)

   

  return (
    <Table
      // locale={locale}
      columns={columns}
      dataSource={report}
      onChange={handleTableChange}
      pagination={tableParams.pagination}
      scroll={{ x: totalWidth, y: "650px" }}
      className={`dark ${isdarkMode ? 'ant-table-expanded-row-fixed-background ant-empty-description ant-table-cell custom-table-raw  custom-table-dark' : 'whitemode'}`}
    />
  );
};

export default RawGrid;

